/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2015, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'jquery',
	'underscore',
	'text!../templates/SelectItemsDialog.template'
], function(View, $, _, selectItemsDialog) {
	/**
	 * CommonSelectItemsDialog presents a picklist dialog to allow selection of a number of items specified by the object
	 * which creates the dialog. Note, currently we allow only the selection of one item at a time, the reason that the object
	 * is name 'Items' is because it would be very easy to extend this class to include the selection of multiple items and
	 * I believe there will be a need for this in the near future. I leave this as an enhancement with the consuming app
	 * specifying if this is a single or mutli select dialog with an option which is passed in.
	 */
	var CommonSelectItemsDialog = View.extend({

		// Allow user to click an itemRow class which results in a call to _selectItem
		events: {
			'primaryaction .itemRow': '_selectItem',
			'keydown .itemRow': '_moveFocus'
		},

		_currentSelectedItem: null,
		_possibleItemsToSelect: null,
		_selectionHandler: null,
		labelsView: false,

		/**
		 * Initialize a new picklist dialog with the specified options.
		 * @param options - an object of the following form
		 *		{
		 *			.....					<= see parent class for options not specific to this dialog
		 *			.currentSelectedItem 	<= (optional) the item currently selected (will be checked)
		 *			.possibleItemsToSelect	<= (required) array of possible items that the user can select
		 *										The Possible Items must be of the form:
		 *											{
		 *												id: item id which is passed back to the eventHandler when an item is selected,
		 *												localizedString: localized string which is shown in the dialog
		 *			.eventHandler			<= (required) the object which handles the selection of an item. This object
		 *										must be able to handle a handleSelection(item) call.
		 *		}
		 */
		init: function(options) {
			// Setup options for the View base class (such as dimensions)
			CommonSelectItemsDialog.inherited('init', this, arguments);

			// This is necessary to support the new SlotActions and WidgetActions format
			this._selectionHandler = options.actions ? { handleSelection: options.actions.apply } : options.eventHandler;
			options = options.state ? options.state : options;

			// Store options needed specifically for this dialog
			const _sortColumnOrder = options.eventHandler && options.eventHandler._sortColumn && options.eventHandler._sortColumn.order;
			this._currentSelectedItem = _sortColumnOrder || options.currentSelectedItem || options.getCurrentSelectedItem && options.getCurrentSelectedItem() || null;
			this._possibleItemsToSelect = options.possibleItems;
			this.labelsView = options.labelsView;
		},

		/**
		 * renders the header with column title and icon, content (possible selectable items) and footer
		 */
		render: function() {
			this.$el
				.addClass('popoverDialogContainer')
				.html(selectItemsDialog);

			this._populateRows();


			var listItem = this.$('.itemRow');
			listItem.attr('role', 'option');

			return this;
		},

		setFocus: function() {
			var selectedItem;
			if (this._currentSelectedItem) {
				selectedItem = this.$('.itemRow[data="' + this._currentSelectedItem + '"]');
			}

			if (!selectedItem || !selectedItem.length) {
				selectedItem = this.$('.itemRow');
			}

			selectedItem.first().focus();
		},


		_moveFocus: function(evt) {
			var $target = $(evt.currentTarget);
			switch(evt.keyCode) {
				case 38: // up
					this._moveToItem($target, $target.prev());
					break;
				case 40: // down
					this._moveToItem($target, $target.next());
					break;
			}
		},

		_moveToItem: function($current, $next) {
			$current.attr('tabindex', '-1');
			$next.focus();
			$next.attr('tabindex', '0');
		},

		/**
		 * mark the selected row with class include.  Remove include on other items
		 * not matching the current selected item.
		 */
		_highlightSelected: function() {
			var selectRows = this.$('.itemRow');
			_.each(selectRows, function(item) {
				var $item = $(item);
				var data = $item.attr('data');
				var bInclude = this._currentSelectedItem === data;
				$item.attr('aria-selected', bInclude);
				if (bInclude) {
					$item.attr('tabindex', '0');
				} else {
					$item.attr('tabindex', '-1');
				}

				$item.toggleClass('include', bInclude);
				$item.find('.check').toggleClass('wfg_checkmark', bInclude);
				$item.find('.text').toggleClass('bold', bInclude);
			}.bind(this));
		},

		/**
		 * create the div containing all rows, then highlight the selected row.
		 */
		_populateRows: function() {
			var items = this.$('.selectItems').empty();
			_.each(this._possibleItemsToSelect, function(possibleItem) {
				var item = $('<div/>').addClass('itemRow').attr({ 'data': possibleItem.id, 'appcues-data-id': possibleItem.id });
				$('<div/>').addClass('check wfg_checkmark').appendTo(item);
				$('<div/>').addClass('text').text(possibleItem.localizedString).appendTo(item);
				item.appendTo(items);
			}.bind(this));
			this._highlightSelected();
		},

		/**
		 * This method will save the selected item, tell the selection handler to handle
		 * selection of the item, and then update the select-able list to ensure highlight correctness.
		 * @param evt - the item clicked
		 */
		_selectItem: function(evt) {
			evt.stopPropagation();
			this._currentSelectedItem = $(evt.currentTarget).attr('data');
			this._selectionHandler.handleSelection(this._currentSelectedItem);
			this._highlightSelected();
		}

	});

	return CommonSelectItemsDialog;
});
